import * as React from "react";
import { PortableText } from "@portabletext/react";
import { CheckIcon } from "@heroicons/react/outline";
import { SectionContainer } from "../layout";
import { Link } from "../atoms/Link";

const featureTextComponents = {
  block: {
    normal: ({ children }) => <span>{children}</span>,
  },
};

const PricingCard = ({
  title,
  description,
  price,
  button,
  featuresTitle,
  features,
}) => (
  <div className="border border-gray-200 rounded-lg shadow-sm divide-y divide-gray-200">
    <div className="p-6">
      <h2 className="text-xl leading-6 font-medium text-gray-900">{title}</h2>
      {description && (
        <p className="mt-4 text-base text-gray-500">{description}</p>
      )}
      <p className="mt-8">
        <span className="text-4xl font-extrabold text-gray-900">{price}</span>
      </p>
      {button?.href && button?.text && (
        <Link
          to={button.href}
          className="mt-8 block w-full bg-action-600 border border-transparent rounded-md py-2 text-base font-medium text-white text-center hover:bg-action-700"
        >
          {button.text}
        </Link>
      )}
    </div>
    {(featuresTitle || features?.length > 0) && (
      <div className="pt-6 pb-8 px-6">
        {featuresTitle && (
          <h3 className="text-xs font-medium text-gray-900 tracking-wide uppercase">
            {featuresTitle}
          </h3>
        )}
        {features?.length > 0 && (
          <ul role="list" className="mt-6 space-y-4">
            {features.map((feature, i) => (
              <li key={feature._key ?? i} className="flex space-x-3">
                <CheckIcon
                  className="flex-shrink-0 h-5 w-5 text-green-500"
                  aria-hidden="true"
                />
                <span className="text-base text-gray-500">
                  <PortableText
                    value={feature.text}
                    components={featureTextComponents}
                  />
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    )}
  </div>
);

export const PricingSection = ({
  textAboveTitle,
  title,
  subtitle,
  description,
  pricingElements,
  backgroundColor,
}) => {
  if (!pricingElements?.length) return null;

  const count = pricingElements.length;

  return (
    <SectionContainer
      textAboveTitle={textAboveTitle}
      title={title}
      description={description}
      className={`${backgroundColor} max-w-7xl mx-auto`}
    >
      <div
        className={`mt-12 space-y-12 max-w-lg mx-auto xl:mt-16 xl:space-y-0 xl:grid xl:grid-cols-${count} xl:gap-6 xl:max-w-none xl:mx-0`}
      >
        {pricingElements.map((element, i) => (
          <PricingCard key={element._key ?? i} {...element} />
        ))}
      </div>
    </SectionContainer>
  );
};
